import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<VirtualFrontDesk::TrialEndModal />\n\n{{outlet}}",{ moduleName: "garaje/pods/virtual-front-desk/template.hbs" })